import { render, staticRenderFns } from "./FileCom.vue?vue&type=template&id=71a8d90e&scoped=true&"
import script from "./FileCom.vue?vue&type=script&lang=js&"
export * from "./FileCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8d90e",
  null
  
)

export default component.exports